import { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Autocomplete,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Divider
} from '@mui/material';

// import { Person } from '../../schema/person';
import { Person, PersonType, Supervisor_job, Position } from '../../schema/person';

import { Area } from '../../schema/area';
import { api } from '../../api';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { OnlineRegister, ActiveStatus } from '../../schema/ptt';

interface JobInfoProps {
  person_id?: string | number;
  editable?: boolean;
  reloadStatus?: () => void;
}

const JobInfo: React.FC<JobInfoProps> = ({ person_id, editable, reloadStatus }: JobInfoProps) => {
  const [activeStatus, setActiveStatus] = useState<ActiveStatus | null>(null);
  // General and Office area
  const [areasGnO, setAreasGnO] = useState<Area[]>([]);
  // Control area
  const [areasC, setAreasC] = useState<Area[]>([]);
  const [OLRList, setOLRList] = useState<OnlineRegister[]>([]);
  const [person_type_list, set_person_type_list] = useState<PersonType[]>([]);

  const [person_supervisor_list, set_person_supervisor_list] = useState<Supervisor_job[]>([]);
  const [position_list, set_position_list] = useState<Position[]>([]);
  // const [supervisorSearchKeyword, setSupervisorSearchKeyword] = useState<string>('');
  // const [person_supervisor, set_person_supervisor] = useState<Supervisor_job | null>(null);
  const [arr_person, set_arr_person] = useState<Supervisor_job[]>([]);

  const [expands, setExpands] = useState<Record<number, boolean>>({});
  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchSupervisor, setSearchSupervisor] = useState<string>('');

  const toggleExpands = (index: number) => {
    const isExpand = expands[index] ? expands[index] : false;
    setExpands({ ...expands, [index]: !isExpand });
  };
  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };

  const changeRegisStatus = (index: number, status: string) => {
    const temp = [...OLRList];
    temp[index].regisStatus = status;
    setOLRList(temp);
  };
  const changeObjectiveWorkName = (index: number, objectiveWorkName: string) => {
    const temp = [...OLRList];
    temp[index].objectiveWorkName = objectiveWorkName;
    setOLRList(temp);
  };
  const changePersonType = (index: number, personType: string) => {
    const temp = [...OLRList];
    temp[index].personName = personType;
    setOLRList(temp);
  };
  const changePosition = (index: number, position: Position | null) => {
    const temp = [...OLRList];
    temp[index].position = position?.position_code || '';
    temp[index].positionName = position?.position_name || '';
    setOLRList(temp);
  };
  const changeSupervisor = (index: number, supervisor: any | null) => {
    const temp = [...OLRList];
    temp[index].empCode = supervisor?.Person.employee_code || '';
    temp[index].employeeApprover = supervisor?.Person.full_name || '';
    temp[index].agencyApprover = supervisor?.department_name || '';
    setOLRList(temp);
    // set_person_supervisor(supervisor);
  };
  const changeStartDate = (index: number, newDate: Dayjs | null) => {
    if (newDate == null) {
      return;
    }
    const temp = [...OLRList];
    temp[index].startDate = `${newDate.format('YYYY-MM-DD')}`;
    setOLRList(temp);
  };
  const changeEndDate = (index: number, newDate: Dayjs | null) => {
    if (newDate == null) {
      return;
    }
    const temp = [...OLRList];
    temp[index].expireDate = `${newDate.format('YYYY-MM-DD')}`;
    setOLRList(temp);
  };
  const changePreregistorTimeStart = (index: number, newDate: Dayjs | null) => {
    if (newDate == null) {
      return;
    }
    const temp = [...OLRList];
    temp[index].peregistorTimeStart = `${newDate.format('HH:mm')}`;
    setOLRList(temp);
  };
  const changePreregistorTimeEnd = (index: number, newDate: Dayjs | null) => {
    if (newDate == null) {
      return;
    }
    const temp = [...OLRList];
    temp[index].peregistorTimeEnd = `${newDate.format('HH:mm')}`;
    setOLRList(temp);
  };
  const changeGeneralOfficeArea = (index: number, areas: Area[]) => {
    const temp = [...OLRList];
    temp[index].areas = [...OLRList[index].areas.filter((data) => data.is_require_wpm), ...areas];
    setOLRList(temp);
  };
  const changeControlArea = (index: number, areas: Area[]) => {
    const temp = [...OLRList];
    temp[index].areas = [...OLRList[index].areas.filter((data) => !data.is_require_wpm), ...areas];
    setOLRList(temp);
  };

  const saveORL = (index: number) => {
    if (!editable) {
      return;
    }
    if (isLoading) {
      return;
    }
    if (index in OLRList) {
      setIsLoading(true);
      api
        .put(`olr/${OLRList[index].id}`, {
          position: OLRList[index].position || '',
          positionName: OLRList[index].positionName || '',
          personName: OLRList[index].personName,
          objectiveWorkName: OLRList[index].objectiveWorkName,
          startDate: OLRList[index].startDate,
          expireDate: OLRList[index].expireDate,
          peregistorTimeStart: OLRList[index].peregistorTimeStart,
          peregistorTimeEnd: OLRList[index].peregistorTimeEnd,
          regisStatus: OLRList[index].regisStatus,
          empCode: OLRList[index].empCode,
          employeeApprover: OLRList[index].employeeApprover,
          agencyApprover: OLRList[index].agencyApprover,
          areas: OLRList[index].areas.map((data) => data.id)
        })
        .then(() => {
          openSuccessDialog();
          reloadStatus && reloadStatus();
        })
        .finally(() => setIsLoading(false));
    }
  };

  const saveTempStatus = () => {
    if (!editable) {
      return;
    }
    if (isLoading) {
      return;
    }
    if (person_id && activeStatus) {
      setIsLoading(true);
      api
        .post(`person/${person_id}/temporary_status`, {
          is_olr_active: activeStatus.is_temp_active,
          olr_comment: activeStatus.comment
        })
        .then(() => {
          openSuccessDialog();
          reloadStatus && reloadStatus();
          useEffect(() => {
            if (person_id) {
              api.get(`person/${person_id}/olr`).then((res) => {
                const { data } = res;
                setOLRList(data);
              });

              api.get(`person/${person_id}/olr/status`).then((res) => {
                const { data } = res;
                setActiveStatus(data);
              });
            }
          }, [person_id]);
        })
        .finally(() => setIsLoading(false));
    }
  };

  const temp_person: any[] | ((prevState: Supervisor_job[]) => Supervisor_job[]) = [];

  useEffect(() => {
    if (person_id) {
      api.get<Area[]>(`/area`).then((res) => {
        const { data } = res;
        setAreasGnO(data.filter((data) => data.is_require_wpm !== true));
        setAreasC(data.filter((data) => data.is_require_wpm === true));
      });
    }
  }, [person_id]);

  useEffect(() => {
    if (person_id) {
      api.get(`person/${person_id}/olr`).then((res) => {
        const { data } = res;
        setOLRList(data);
        data.forEach((element: { empCode: any }) => {
          api.get(`staff`, { params: { employee_code: element.empCode } }).then((res) => {
            const { data } = res;
            temp_person.push(data[0]);
            set_arr_person(temp_person);
            // set_person_supervisor_list(arr_person);
            // set_person_supervisor(data);
            // return data;
          });
        });
      });

      api.get(`person/${person_id}/olr/status`).then((res) => {
        const { data } = res;
        setActiveStatus(data);
      });
    }
  }, [person_id]);

  useEffect(() => {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('name', searchSupervisor);
        searchParams.set('limit', '10');

        api.get(`staff`, { params: searchParams }).then((res) => {
          const { data } = res;
          set_person_supervisor_list(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
  }, [searchSupervisor]);

  useEffect(() => {
    api.get(`person-type`).then((res) => {
      const { data } = res;
      set_person_type_list(data);
    });
    api.get(`staff`, { params: { limit: 10 } }).then((res) => {
      const { data } = res;
      set_person_supervisor_list(data);
    });
    api.get(`position`).then((res) => {
      const { data } = res;
      set_position_list(data);
    });
  }, []);

  return (
    <>
      <Typography variant="h6">การอนุญาต</Typography>
      {activeStatus?.is_active ? (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="สถานะการอนุญาต"
                variant="outlined"
                placeholder="สถานะการอนุญาต"
                value={'ผ่านโดยระบบ'}
                autoComplete="off"
                InputProps={{
                  readOnly: true
                }}
              />
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              {editable ? (
                <FormControl fullWidth>
                  <InputLabel id="is_active">สถานะการอนุญาต</InputLabel>
                  <Select
                    labelId="is_active"
                    label="สถานะการอนุญาต"
                    variant="outlined"
                    onChange={(e) =>
                      activeStatus
                        ? setActiveStatus({
                            ...activeStatus,
                            is_temp_active: e.target.value == 'true'
                          })
                        : null
                    }
                    value={`${activeStatus?.is_temp_active === true}`}
                    autoComplete="off"
                    disabled={!activeStatus}
                  >
                    <MenuItem value={'true'}>ผ่าน</MenuItem>
                    <MenuItem value={'false'}>ไม่ผ่าน</MenuItem>
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  fullWidth
                  label="สถานะการอนุญาต"
                  variant="outlined"
                  placeholder="สถานะการอนุญาต"
                  value={activeStatus?.is_temp_active ? 'ผ่าน' : 'ไม่ผ่าน'}
                  autoComplete="off"
                  InputProps={{
                    readOnly: true
                  }}
                />
              )}
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                label="หมายเหตุการอนุญาตชั่วคราวโดยเจ้าหน้าที่"
                variant="outlined"
                placeholder="หมายเหตุการอนุญาตชั่วคราวโดยเจ้าหน้าที่"
                onChange={(e) =>
                  activeStatus
                    ? setActiveStatus({ ...activeStatus, comment: e.target.value })
                    : null
                }
                value={activeStatus?.comment ? activeStatus.comment : ''}
                autoComplete="off"
                disabled={!activeStatus}
              />
            </Grid>
          </Grid>
          {editable ? (
            <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
              <Grid item>
                <Button onClick={() => saveTempStatus()} variant="contained" color="primary">
                  บันทึก
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Box>
      )}
      <Divider sx={{ mt: 3 }} />
      {OLRList.length == 0 ? (
        <Typography variant="h6" mt={3} sx={{ color: "red" }}>
          ไม่พบข้อมูล Online Register โปรดตรวจสอบ สถานะและวันทีเข้า-ออกเข้าพื้นที่ในระบบ Online Register
            {/* <Typography variant="subtitle2" mt={1} sx={{ color: "black" }}>
              กรุณาตรวจสอบข้อมูลการลงทะเบียนผ่านระบบ Online Register
            </Typography> */}
        </Typography>
      ) : (
        <>
          <Typography variant="h6" mt={3}>
            ข้อมูล Online Register
          </Typography>
          <Box sx={{ mt: 2 }}>
            {OLRList.map((olrData, index) => {
              const startDate = dayjs(olrData.startDate);
              const expireDate = dayjs(olrData.expireDate);

              const peregistorTimeStart = dayjs(olrData.peregistorTimeStart, 'HH:mm');
              const peregistorTimeEnd = dayjs(olrData.peregistorTimeEnd, 'HH:mm');

              // useEffect(() => {
              // api.get(`staff`, { params: { employee_code: olrData.empCode } }).then((res) => {
              //   const { data } = res;
              //   const arr_person = person_supervisor_list
              //   arr_person.push(data);
              //   console.log(arr_person)
              //   // set_person_supervisor_list(arr_person);
              //   set_person_supervisor(data);
              //   return data;
              // });
              // }, []);

              // const supervisor: Supervisor_job | null = api.get(`staff`, { params: { employee_code: olrData.empCode } }).then((res) => {const { data } = res; return}) ||
              // null;
              const supervisor: Supervisor_job | null = 
              arr_person.concat(person_supervisor_list).find((data) => data?.Person.employee_code == olrData.empCode) || null;

              const position: Position | null =
                position_list.find((data) => data.position_code == olrData.position) || null;

              return (
                <Card sx={{ marginBottom: 3, border: 1, borderColor: '#E5E5E5' }} key={index}>
                  <CardContent
                    sx={{
                      p: 2,
                      '&:last-child': {
                        paddingBottom: 2
                      }
                    }}
                  >
                    <Grid
                      container
                      alignItems="center"
                      onClick={() => toggleExpands(index)}
                      sx={{ cursor: 'pointer' }}
                    >
                      <Grid item xs={10}>
                        <Typography variant="h6">{` เลขที่ใบงาน ${olrData.regisID}`}</Typography>
                      </Grid>
                      <Grid item xs={2} sx={{ textAlign: 'right' }}>
                        <IconButton onClick={() => toggleExpands(index)}>
                          {!expands[index] ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                        </IconButton>
                      </Grid>
                    </Grid>
                    {/* <Grid container spacing={2}>
                  <Grid item xs={3} mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="is_active">สถานะการอนุญาต</InputLabel>
                      <Select
                        labelId="is_active"
                        label="สถานะการอนุญาต"
                        variant="outlined"
                        // onChange={(e) => setIsActive(e.target.value == 'true')}
                        // value={`${isActive}`}
                        autoComplete="off"
                      >
                        <MenuItem value="true">ผ่าน</MenuItem>
                        <MenuItem value="false">ไม่ผ่าน</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={9} mt={2}>
                    <TextField
                      fullWidth
                      label="หมายเหตุการอนุญาตโดยเจ้าหน้าที่"
                      variant="outlined"
                      placeholder="หมายเหตุการอนุญาตโดยเจ้าหน้าที่"
                    />
                  </Grid>
                </Grid> */}
                    <Collapse in={expands[index]}>
                      <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            {editable ? (
                              <FormControl fullWidth>
                                <InputLabel id="person_type">สถานะใบงาน</InputLabel>
                                <Select
                                  labelId="is_active"
                                  label="สถานะใบงาน"
                                  variant="outlined"
                                  onChange={(e) =>
                                    changeRegisStatus(
                                      index,
                                      e.target.value == 'true' ? 'Approve' : 'Reject'
                                    )
                                  }
                                  value={`${olrData.regisStatus == 'Approve'}`}
                                  autoComplete="off"
                                >
                                  <MenuItem value="true">Approve</MenuItem>
                                  <MenuItem value="false">Reject</MenuItem>
                                </Select>
                              </FormControl>
                            ) : (
                              <TextField
                                fullWidth
                                label="สถานะใบงาน"
                                variant="outlined"
                                placeholder="สถานะใบงาน"
                                value={olrData.regisStatus ? olrData.regisStatus : ''}
                                InputProps={{ readOnly: !editable }}
                              />
                            )}
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="วัตถุประสงค์"
                              variant="outlined"
                              placeholder="วัตถุประสงค์"
                              value={olrData.objectiveWorkName}
                              onChange={(e) => changeObjectiveWorkName(index, e.target.value)}
                              InputProps={{ readOnly: !editable }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            {editable ? (
                              <FormControl fullWidth>
                                <InputLabel id="person_type">ประเภทบุคคล</InputLabel>
                                <Select
                                  labelId="person_type"
                                  value={olrData?.personName}
                                  label="ประเภทบุคคล"
                                  name="status"
                                  onChange={(e) => changePersonType(index, e.target.value)}
                                >
                                  {person_type_list.map((data, index) => {
                                    return (
                                      <MenuItem key={index} value={data.type_name}>
                                        {data.type_name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            ) : (
                              <TextField
                                fullWidth
                                label="ประเภทบุคคล"
                                variant="outlined"
                                placeholder="ประเภทบุคคล"
                                value={olrData?.personName ? olrData?.personName : ''}
                                InputProps={{ readOnly: !editable }}
                              />
                            )}
                          </Grid>

                          {/* <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="ตำแหน่ง"
                              variant="outlined"
                              placeholder="ตำแหน่ง"
                              value={olrData.positionName}
                              onChange={(e) => changePosition(index, e.target.value)}
                              InputProps={{ readOnly: !editable }}
                            />
                          </Grid> */}

                          <Grid item xs={6}>
                            {editable ? (
                              <Autocomplete
                                disablePortal
                                id="position"
                                options={position_list}
                                getOptionLabel={(option) =>
                                  option?.position_name ? option.position_name : ''
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    label="ตำแหน่ง"
                                    required
                                  />
                                )}
                                value={position}
                                onChange={(_, value) => changePosition(index, value ? value : null)}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              />
                            ) : (
                              <TextField
                                fullWidth
                                label="ตำแหน่ง"
                                variant="outlined"
                                placeholder="ตำแหน่ง"
                                value={position?.position_name ? position.position_name : ''}
                              />
                            )}
                          </Grid>
                          <Grid item xs={6}>
                            {editable ? (
                              <Autocomplete
                                disablePortal
                                id="supervisor"
                                options={person_supervisor_list}
                                getOptionLabel={(option) =>
                                  option?.Person.first_name
                                    ? option.Person.first_name + ' ' + option.Person.last_name
                                    : ''
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    label="ผู้คุมงาน"
                                    required
                                  />
                                )}
                                value={supervisor}
                                onChange={(_, value) =>
                                  changeSupervisor(index, value ? value : null)
                                }
                                onInputChange={(_, newInputValue) => {
                                  setSearchSupervisor(newInputValue);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option?.Person.id === value?.Person.id
                                }
                              />
                            ) : (
                              <TextField
                                fullWidth
                                label="ผู้คุมงาน"
                                variant="outlined"
                                placeholder="ผู้คุมงาน"
                                value={supervisor?.Person.first_name + " " + supervisor?.Person.last_name}
                              />
                            )}
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="หน่วยงานของผู้คุมงาน"
                              variant="outlined"
                              placeholder="หน่วยงานของผู้คุมงาน"
                              value={supervisor?.department_name ? supervisor.department_name : ''}
                              InputProps={{ readOnly: true }}
                              disabled={!supervisor?.department_name}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="เบอร์โทรศัพท์ผู้คุมงาน"
                              variant="outlined"
                              placeholder="เบอร์โทรศัพท์ผู้คุมงาน"
                              value={supervisor?.Person.phone_number ? supervisor.Person.phone_number : ''}
                              InputProps={{ readOnly: true }}
                              disabled={!supervisor?.Person.phone_number}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Email ผู้คุมงาน"
                              variant="outlined"
                              placeholder="Email ผู้คุมงาน"
                              value={supervisor?.Person.email ? supervisor.Person.email : ''}
                              InputProps={{ readOnly: true }}
                              disabled={!supervisor?.Person.email}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DesktopDatePicker
                                label="วันที่เข้าหน้างาน"
                                inputFormat="DD/MM/YYYY"
                                value={startDate as any}
                                onChange={(date) => changeStartDate(index, date)}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                readOnly={!editable}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DesktopDatePicker
                                label="วันที่สิ้นสุด"
                                inputFormat="DD/MM/YYYY"
                                value={expireDate as any}
                                onChange={(date) => changeEndDate(index, date)}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                readOnly={!editable}
                              />
                            </LocalizationProvider>
                          </Grid>

                          <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="เวลาเข้าหน้างาน"
                                inputFormat="HH:mm"
                                value={peregistorTimeStart as any}
                                onChange={(date) => changePreregistorTimeStart(index, date)}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                readOnly={!editable}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="เวลาออก"
                                inputFormat="HH:mm"
                                value={peregistorTimeEnd as any}
                                onChange={(date) => changePreregistorTimeEnd(index, date)}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                readOnly={!editable}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography variant="h6" mt={2}>
                              ข้อมูลขอเข้าพื้นที่
                            </Typography>
                          </Grid>
                          <Grid item xs={6} mt={2}>
                            {editable ? (
                              <Autocomplete
                                multiple
                                disablePortal
                                options={areasGnO}
                                getOptionLabel={(option) => option.area_name}
                                renderInput={(params) => (
                                  <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />
                                )}
                                value={olrData.areas.filter((data) => data.is_require_wpm !== true)}
                                onChange={(_, value) => changeGeneralOfficeArea(index, value)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                              />
                            ) : (
                              <Autocomplete
                                multiple
                                disablePortal
                                options={areasC}
                                getOptionLabel={(option) =>
                                  typeof option != 'string' ? option.area_name : option
                                }
                                renderInput={(params) => (
                                  <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />
                                )}
                                value={olrData.areas.filter((data) => data.is_require_wpm !== true)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                readOnly
                                freeSolo
                              />
                            )}
                          </Grid>
                          <Grid item xs={6} mt={2}>
                            {editable ? (
                              <Autocomplete
                                multiple
                                disablePortal
                                options={areasC}
                                getOptionLabel={(option) => option.area_name}
                                renderInput={(params) => (
                                  <TextField {...params} label="พื้นที่ควบคุม" />
                                )}
                                value={olrData.areas.filter((data) => data.is_require_wpm === true)}
                                onChange={(_, value) => changeControlArea(index, value)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                              />
                            ) : (
                              <Autocomplete
                                multiple
                                disablePortal
                                options={areasC}
                                getOptionLabel={(option) =>
                                  typeof option != 'string' ? option.area_name : option
                                }
                                renderInput={(params) => (
                                  <TextField {...params} label="พื้นที่ควบคุม" />
                                )}
                                value={olrData.areas.filter((data) => data.is_require_wpm === true)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                readOnly
                                freeSolo
                              />
                            )}
                          </Grid>
                          {editable ? (
                            <Grid container columns={2} spacing={2} direction={'row-reverse'}>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  sx={{ marginTop: 4 }}
                                  onClick={() => saveORL(index)}
                                >
                                  บันทึก
                                </Button>
                              </Grid>
                            </Grid>
                          ) : null}
                        </Grid>
                      </Box>
                    </Collapse>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        </>
      )}
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default JobInfo;
